/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const QsChecksProblemTypes = {
    QsChecksPrueflaufGeloescht: 'QsChecksPrueflaufGeloescht',
    QsChecksPrueflaufNichtGefunden: 'QsChecksPrueflaufNichtGefunden',
    QsChecksPruefplanEntfernt: 'QsChecksPruefplanEntfernt',
    QsChecksPruefplanNichtGefunden: 'QsChecksPruefplanNichtGefunden',
    QsChecksKeinController: 'QsChecksKeinController',
    QsChecksKeinPrueflaufZugriff: 'QsChecksKeinPrueflaufZugriff',
    QsChecksKeinZugriff: 'QsChecksKeinZugriff',
    QsChecksKeinPruefplanZugriff: 'QsChecksKeinPruefplanZugriff',
    QsChecksKeinPruefplanAdminZugriff: 'QsChecksKeinPruefplanAdminZugriff',
    QsCheckModulNichtAktiv: 'QsCheckModulNichtAktiv'
} as const;
export type QsChecksProblemTypes = typeof QsChecksProblemTypes[keyof typeof QsChecksProblemTypes];

